import { Link } from 'react-router-dom';
import { useTranslation } from '@yorukiri/i18n';
import { colors } from '@yorukiri/ui/tokens';
import { ArrowLeft } from './icons';

type Stats = { got: number; again: number; elapsed: string };

export function ReviewTopbar({
  pageTitle,
  position,
  total,
  stats,
}: {
  pageTitle: string;
  position: number;
  total: number;
  stats: Stats;
}) {
  const { t } = useTranslation('review');
  return (
    <div
      style={{
        padding: '14px 24px',
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        gap: 20,
        borderBottom: `1px solid ${colors.line}`,
      }}
    >
      <Link
        to="/"
        style={{
          justifySelf: 'start',
          fontVariantNumeric: 'tabular-nums',
          fontSize: 11,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: colors.ink3,
          background: 'transparent',
          border: `1px solid ${colors.line2}`,
          padding: '6px 12px',
          borderRadius: 5,
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <ArrowLeft size={12} /> {t('exit')}
      </Link>

      <div style={{ textAlign: 'center' }}>
        <span
          style={{
            fontVariantNumeric: 'tabular-nums',
            fontSize: 10,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: colors.accent,
            display: 'block',
            marginBottom: 2,
          }}
        >
          {pageTitle}
        </span>
        <span style={{ fontWeight: 600, letterSpacing: '-0.01em', fontSize: 20 }}>
          {t('session')}{' '}
          <em style={{ fontStyle: 'italic', color: colors.ink3 }}>
            {t('session_progress', { position, total })}
          </em>
        </span>
      </div>

      <div style={{ justifySelf: 'end', display: 'flex', gap: 20 }}>
        <Stat label={t('stats.got')} value={stats.got} tone="sage" />
        <Stat label={t('stats.again')} value={stats.again} tone="accent" />
        <Stat label={t('stats.elapsed')} value={stats.elapsed} />
      </div>
    </div>
  );
}

function Stat({
  label,
  value,
  tone,
}: {
  label: string;
  value: string | number;
  tone?: 'sage' | 'accent';
}) {
  const c = tone === 'sage' ? colors.good : tone === 'accent' ? colors.accent : colors.ink;
  return (
    <div style={{ textAlign: 'right' }}>
      <div
        style={{
          fontVariantNumeric: 'tabular-nums',
          fontSize: 9,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: colors.ink3,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontWeight: 600,
          letterSpacing: '-0.01em',
          fontSize: 20,
          lineHeight: 1,
          color: c,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value}
      </div>
    </div>
  );
}
